import { deleteCandidateDocumentThunk, uploadsCandidateDocumentThunk } from './thunks'
import {
    IUploadsState
} from './types'
import { createSlice } from '@reduxjs/toolkit'

const initialState: IUploadsState = {
    initial: null,
    inProgress: false,
    error: '',
    document: null
}

const uploadsSlice = createSlice({
    name: 'uploads',
    initialState,
    reducers: {
        resetUploadsErrorAction: (state) => {
            state.error = null
        },
    },
    extraReducers: (builder) => {
        // upload-candidate-documents
        builder.addCase(uploadsCandidateDocumentThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(uploadsCandidateDocumentThunk.fulfilled, (state, action) => {
            state.inProgress = false
            state.document = action.payload
        })
        builder.addCase(uploadsCandidateDocumentThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })

        // delete-candidate-documents
        builder.addCase(deleteCandidateDocumentThunk.pending, (state, action) => {
            state.inProgress = true
            state.error = null
        })
        builder.addCase(deleteCandidateDocumentThunk.fulfilled, (state, action) => {
            state.inProgress = false
        })
        builder.addCase(deleteCandidateDocumentThunk.rejected, (state, action) => {
            state.inProgress = false
            state.error = action.payload
        })
    }
});

export const {
    resetUploadsErrorAction
} = uploadsSlice.actions

export default uploadsSlice.reducer;